import eSendingModeCookieName from "~/enums/eSendingModeCookieName"

const cookieSendingModeInvoice = eSendingModeCookieName.INVOICE


export { cookieSendingModeInvoice }
